// TypeScript mirror of StakeMeta.sol constants.
// Mount-time sanity check in useStakeConstants.ts verifies these match on-chain values.
export const STAKE_CONSTANTS = {
  TIME_STEP_SECONDS: 86_400n,
  REWARD_DECAY_FACTOR: 20n,
  REWARD_DECAY_PERIOD_SECONDS: 31_536_000n,
  STAKE_MAX_DNM_WEI: 28_000_000_000_000_000_000n,
  STAKE_MIN_DNM_WEI: 1_000_000_000_000_000_000n,
  STAKE_MAX_UVM_WEI: 6_000_000_000_000_000_000_000n,
  ONE_YEAR_SECONDS: 31_536_000n,
  EIGHTEEN_MONTH_SECONDS: 47_260_800n, // 547 days (NOT 18x30 or 18x30.4)
  TWO_YEAR_SECONDS: 63_072_000n,
} as const;

/**
 * Pure client-side port of StakeMeta.calDnmUvmRatio.
 * Uses bigint arithmetic — no floating point rounding.
 */
export function calDnmUvmRatio(dnmWei: bigint): bigint {
  return (
    (STAKE_CONSTANTS.STAKE_MAX_UVM_WEI * dnmWei) /
    STAKE_CONSTANTS.STAKE_MAX_DNM_WEI
  );
}
